import { render, staticRenderFns } from "./BadCode.vue?vue&type=template&id=41c34a71&scoped=true&"
import script from "./BadCode.vue?vue&type=script&lang=js&"
export * from "./BadCode.vue?vue&type=script&lang=js&"
import style0 from "./BadCode.vue?vue&type=style&index=0&id=41c34a71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c34a71",
  null
  
)

export default component.exports